// 계약종료 표시 — 단일 규칙(2026-10-06).
//
// 판정은 서버의 is_contract_ended(User 모델 단일 출처: 마지막 근로일이 과거 OR 퇴직자)만
// 쓴다. ⚠️ 이름 문자열에 "계약종료"가 들어 있는지로 판정하던 방식은 폐기했다 — 이름은
// 급여 매핑 등이 완전일치로 쓰는 원본이라 절대 바꾸지 않고, 표시는 렌더링 시점에만 붙인다.
//
// 화면 규칙은 두 가지뿐이다.
//  · 기록 조회 목록(캘린더·휴가시간 관리·성과 조회): 표시 + 맨 아래 정렬 → withEndedLabel / sortEndedLast
//  · 새로 지정·부여하는 목록(결재선·업무 지시·담당자 선택 등): 제외 → isActiveStaff

export const CONTRACT_ENDED_LABEL = "(계약종료)";

export const isContractEnded = (u) => Boolean(u?.is_contract_ended);

// 이름(또는 "이름 직급") 뒤에 표기를 붙인다. 원본 값은 건드리지 않는다.
export const withEndedLabel = (label, ended) =>
  ended ? `${label} ${CONTRACT_ENDED_LABEL}` : label;

// 계약종료자를 맨 아래로 — 나머지 순서는 그대로 둔다(안정 정렬).
export const sortEndedLast = (list, isEnded = isContractEnded) =>
  [...list].sort((a, b) => Number(isEnded(a)) - Number(isEnded(b)));

// 지정·부여 대상 목록용: 계약종료자 제외.
export const isActiveStaff = (u) => !isContractEnded(u);
